import { createContext, useContext } from 'react';

export const PhoneToastContext = createContext<(message: string) => void>(() => {});

export const usePhoneToast = () => useContext(PhoneToastContext);
